import { stringify as stringifyQs } from "qs";
import urljoin from "url-join";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";
import { SaleDetailsPageTab } from "./components/SaleDetailsPage";
import { VoucherDetailsPageTab } from "./components/VoucherDetailsPage";
import {
  CustomerPagination,
  MallsPagination,
  ProductPagination
} from "./views/VoucherDetails/utils";

export const discountSection = "/discounts/";

export const saleSection = urlJoin(discountSection, "sales");
export const saleListPath = saleSection;
export enum SaleListUrlFiltersEnum {
  type = "type",
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  query = "query"
}
export enum SaleListUrlFiltersWithMultipleValues {
  status = "status"
}
export type SaleListUrlFilters = Filters<SaleListUrlFiltersEnum> &
  FiltersWithMultipleValues<SaleListUrlFiltersWithMultipleValues>;
export type SaleListUrlDialog =
  | "remove"
  | "deactivate"
  | "uploadSalesMerchantPercentage"
  | "uploadSalesPartnerPercentage"
  | "uploadSalesMerchantAbsolute"
  | "uploadSalesPartnerAbsolute"
  | TabActionDialog;
export enum SaleListUrlSortField {
  name = "name",
  endDate = "end-date",
  startDate = "start-date",
  type = "type",
  value = "value"
}
export type SaleListUrlSort = Sort<SaleListUrlSortField>;
export interface KAMSUrlQueryParams {
  brand?: string;
}
export type SaleListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<SaleListUrlDialog> &
  Pagination &
  SaleListUrlFilters &
  SaleListUrlSort &
  KAMSUrlQueryParams;
export const saleListUrl = (params?: SaleListUrlQueryParams) =>
  saleListPath + "?" + stringifyQs(params);
export const salePath = (id: string) => urlJoin(saleSection, id);
export type SaleUrlDialog =
  | "assign-category"
  | "assign-collection"
  | "assign-product"
  | "assign-store"
  | "unassign-category"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-store"
  | "deactivate"
  | "remove";
export type SaleUrlQueryParams = Pagination &
  BulkAction &
  Dialog<SaleUrlDialog> &
  ActiveTab<SaleDetailsPageTab> &
  KAMSUrlQueryParams;
export const saleUrl = (id: string, params?: SaleUrlQueryParams) =>
  salePath(encodeURIComponent(id)) + "?" + stringifyQs(params);
export const saleAddPath = urlJoin(saleSection, "add");
export const saleAddUrl = saleAddPath;

export const voucherSection = urlJoin(discountSection, "vouchers");
export const voucherListPath = voucherSection;
export enum VoucherListUrlFiltersEnum {
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  timesUsedFrom = "timesUsedFrom",
  timesUsedTo = "timesUsedTo",
  query = "query",
  hasGroup = "hasGroup"
}
export enum VoucherListUrlFiltersWithMultipleValues {
  status = "status",
  type = "type",
  voucherType = "voucherType"
}

export type VoucherListUrlFilters = Filters<VoucherListUrlFiltersEnum> &
  FiltersWithMultipleValues<VoucherListUrlFiltersWithMultipleValues>;
export type VoucherListUrlDialog =
  | "remove"
  | "deactivate"
  | "status"
  | TabActionDialog;
export enum VoucherListUrlSortField {
  code = "code",
  endDate = "end-date",
  limit = "limit",
  minSpent = "min-spent",
  startDate = "start-date",
  type = "type",
  value = "value"
}
export type VoucherListUrlSort = Sort<VoucherListUrlSortField>;
export type VoucherListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<VoucherListUrlDialog> &
  Pagination &
  VoucherListUrlFilters &
  VoucherListUrlSort;
export const voucherListUrl = (params?: VoucherListUrlQueryParams) =>
  voucherListPath + "?" + stringifyQs(params);
export const voucherGroupListUrl = (
  params?: VoucherListUrlQueryParams,
  id?: string
) => bulkVoucherPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
export const voucherPath = (id: string) => urlJoin(voucherSection, id);
export type VoucherUrlDialog =
  | "edit-store"
  | "assign-category"
  | "assign-collection"
  | "assign-country"
  | "assign-customers"
  | "assign-product"
  | "assign-product-e-voucher"
  | "assign-mall"
  | "assign-stores"
  | "unassign-category"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-customer"
  | "remove"
  | "download"
  | "status";
export type VoucherUrlQueryParams = Pagination &
  BulkAction &
  Dialog<VoucherUrlDialog> &
  ActiveTab<VoucherDetailsPageTab> &
  ProductPagination &
  CustomerPagination &
  MallsPagination;
export const voucherUrl = (id: string, params?: VoucherUrlQueryParams) =>
  voucherPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const voucherAddPath = urlJoin(voucherSection, "add");
export const voucherAddUrl = voucherAddPath;

export const bulkVoucherSection = urljoin(discountSection, "bulk-vouchers");
export const bulkVoucherListPath = bulkVoucherSection;

export enum BulkVoucherListUrlFiltersEnum {
  query = "query"
}

export type BulkVoucherListUrlFilters = Filters<BulkVoucherListUrlFiltersEnum>;
export type BulkVoucherListUrlDialog =
  | "remove"
  | "deactivate"
  | "status"
  | "download"
  | TabActionDialog;

export type BulkVoucherListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<BulkVoucherListUrlDialog> &
  Pagination &
  BulkVoucherListUrlFilters;
export const bulkVoucherPath = (id: string) => urlJoin(bulkVoucherSection, id);

export const bulkVoucherListUrl = (
  id?: string,
  params?: BulkVoucherListUrlQueryParams
) => bulkVoucherPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
